import React from "react";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import About from "../components/landing/About";
import Podcast from "../components/landing/Podcast";
import Book from "../components/landing/Book";
import Classes from "../components/landing/Classes";
import SubmitQuestion from "../components/landing/SubmitQuestion";
import EncourageAndSpeaking from "../components/landing/EncourageAndSpeaking";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";

const Landing = () => {
  return (
    <main className="bg-white text-slate-700 selection:bg-amber-100">
      <Navbar />
      <Hero />
      <About />
      <Podcast />
      <Book />
      <Classes />
      <SubmitQuestion />
      <EncourageAndSpeaking />
      <Contact />
      <Footer />
    </main>
  );
};

export default Landing;
